import { createReducer, on } from '@ngrx/store';
import { AnnouncementDetailEntitiesState } from './announcement-detail-entities.state';
import { announcementDetailEntitiesStateInitial } from './announcement-detail-entities.state.initial';
import { AnnouncementDetailEntitiesActions } from './announcement-detail-entities.actions';
import { announcementDetailEntitiesAdapter } from './announcement-detail-entities.adapter';

/**
 * Reducer für Announcement-Detail-Entities.
 */
export const announcementDetailEntitiesReducers = createReducer(
  announcementDetailEntitiesStateInitial,

  on(
    AnnouncementDetailEntitiesActions.loadDetail,
    (state): AnnouncementDetailEntitiesState => ({
      ...state,
      isLoadingDetail: true,
      isDetailLoaded: false,
      detailError: null,
    }),
  ),

  on(
    AnnouncementDetailEntitiesActions.loadDetailSuccess,
    (state, { detail }) =>
      announcementDetailEntitiesAdapter.upsertOne(detail, {
        ...state,
        isLoadingDetail: false,
        isDetailLoaded: true,
        detailError: null,
      }),
  ),

  on(
    AnnouncementDetailEntitiesActions.loadDetailFailure,
    (state, { error }): AnnouncementDetailEntitiesState => ({
      ...state,
      isLoadingDetail: false,
      isDetailLoaded: true,
      detailError: error,
    }),
  ),

  on(
    AnnouncementDetailEntitiesActions.clearDetail,
    (state, { id }) =>
      announcementDetailEntitiesAdapter.removeOne(id, state),
  ),

  on(
    AnnouncementDetailEntitiesActions.clearAll,
    (state) =>
      announcementDetailEntitiesAdapter.removeAll(state),
  ),
);
